import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'
import clsx from 'clsx'
import { SizeVariant } from 'enums'

import { Button } from 'components/buttons'
import LoadingWrapper from 'components/LoadingWrapper'
import Title from 'components/Title'

import { IArticleCommetsProps } from '../types'

import { Comment } from './components'

const ArticleComments = ({
  className,
  isLoading,
  comments,
  onCreateComment,
  onReplyComment
}: IArticleCommetsProps) => {
  const { t } = useTranslation(['community'])

  const reversedArray = useMemo(
    () => [...(comments ?? [])].reverse(),
    [comments]
  )

  return (
    <div className={clsx(className, 'px-10 py-8')}>
      <div className="flex justify-between">
        <Title variant="h2" className="text-x" showDot={false}>
          {t('comments', { ns: 'community' })}
        </Title>
        <Button
          size={SizeVariant.Small}
          className="border-none"
          onClick={onCreateComment}
        >
          {t('createComment', { ns: 'community' })}
        </Button>
      </div>
      <LoadingWrapper
        data={reversedArray}
        checkEmpty
        emptyText=""
        isLoading={isLoading}
      >
        {(data) => {
          return (
            <div className="mt-8 flex flex-col gap-8">
              {data.map((comment) => (
                <Comment
                  key={comment.id}
                  className="border-b-2 pb-8"
                  comment={comment}
                  onReplyComment={onReplyComment}
                />
              ))}
            </div>
          )
        }}
      </LoadingWrapper>
    </div>
  )
}

export default ArticleComments
